var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alertStatus)?_c('div',[_c('v-alert',{attrs:{"type":_vm.type}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }